export function isTrue(isTrue: string | boolean | undefined | null): boolean {
  if (!isTrue) {
    return false;
  }
  return typeof isTrue === 'boolean'
    ? isTrue
    : TRUTHY_STRING_LIST.includes(isTrue.toLowerCase());
}

const TRUTHY_STRING_LIST = ['true', 'y', 'yes'];
